import { Preset } from '@modules/common/components/DateRangePicker/hooks/useDatePresets';
import dayjs from 'dayjs';

export const DASHBOARD_QUICK_FILTER_OPTIONS = {
  skipYesterday: true,
};

export const DEFAULT_DATE_PRESET: Preset = {
  timeRange: {
    type: 'since',
    startAfter: dayjs(null),
  },
  displayName: 'Default',
  title: 'Date range set in the respective Quantify',
  dateRangeString: '',
};
